module.exports = {
  path: ':reference/extend',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MyOnDemandAccessExtend'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/my_on_demand_access/routes/extend/index.js